// extracted by mini-css-extract-plugin
var _1 = "_XYiq";
var _2 = "ypdaX";
var _3 = "anWWF";
var _4 = "QRnGz";
var _5 = "wk5R7";
var _6 = "TynD9";
var _7 = "cl8IB";
export { _1 as "base", _2 as "content", _3 as "count", _4 as "header", _5 as "tab", _6 as "tabgroups", _7 as "trigger" }
